import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { thrash } from '../../assets/svg/other'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal/Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { Input, } from '../../components/ModalInputs'
import moment from 'moment'
import CustomSelect from '../../components/CustomSelect'
import { deleteDocumentJournal, getDocumentJournal, getDocumentJournalList } from '../../actions/documents_journal'
import { getTypesOfDocumentsList } from '../../actions/typesOfDocuments'


const arrHow = [{ name: 'Учителя', id: 1 }, { name: 'Учащиеся', id: 2 }]
const dateFormat = 'YYYY-MM-DD';
const defaultDate = {
  begdate: moment().startOf('month').format(dateFormat),
  enddate: moment().endOf('month').format(dateFormat)
};

export default function DocumentsJournal() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { docList } = useSelector(state => state.documents_journal)
  const { typeOfDocumentslist } = useSelector(state => state.types_of_documents)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [date, setDate] = useState(defaultDate); // Дата для поиска

  useEffect(() => {
    dispatch(getDocumentJournalList(date))
    dispatch(getTypesOfDocumentsList())
  }, [])

  useEffect(() => {
    if (selectedItem?.xp_key) dispatch(getDocumentJournal(selectedItem.xp_key))
  }, [selectedItem])


  const openModal = (data) => () => {
    if (data?.xp_key) {
      const dtype = typeOfDocumentslist?.find(t => t.name === data.name)?.xp_key
      setSelectedItem({ ...data, dtype })
    } else {
      setSelectedItem(data || {})
    }
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')


  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteDocumentJournal(confirmation.id, date));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { ddate, fio, owner, name, dseries, xp_key, dnum, dtext } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{fio}</td>
        <td onClick={openModal(data)}>{owner}</td>
        <td onClick={openModal(data)}>{name}</td>
        <td onClick={openModal(data)}>{ddate && moment(ddate).format('DD.MM.YYYY')}</td>
        <td onClick={openModal(data)}>{dseries}</td>
        <td onClick={openModal(data)}>{dnum}</td>
        <td onClick={openModal(data)}>{dtext}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: xp_key, name: fio })}><BiTrash /></i></td>
      </tr>
    )
  }

  const dateChangeHandler = (name, value) => { // Обработчик изменения дат
    setDate({ ...date, [name]: moment(value).format(dateFormat) });
  }
  const setFieldValue = (name, value) => {
    setDate({ ...date, [name]: value });
  }

  const refresh = (date) => {
    dispatch(getDocumentJournalList(date))
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          params={date}
          typeOfDocumentslist={typeOfDocumentslist}
        />
      }
      <h1>Журнал документов</h1>
      <div className={styles.inputsRow}>
        <div>
          <span className={styles.label}>Период:</span>
          <div style={{ display: 'flex', gap: '10px', }}>
            <Input type='date' value={date.begdate} onChange={(e) => dateChangeHandler('begdate', e.target.value)} />
            <Input type='date' value={date.enddate} onChange={(e) => dateChangeHandler('enddate', e.target.value)} />
          </div>
        </div>
        <CustomSelect
          title='Владелец'
          valuesName="owner"
          options={arrHow.map(el => ({ name: el.name, value: el.id }))}
          className={styles.selectTop}
          value={date.owner ?? ''}
          setFieldValue={setFieldValue}
          width={170}
          searchable={false}
        />
        <CustomSelect
          title='Вид документа'
          valuesName="dtype"
          options={typeOfDocumentslist?.map(el => ({ name: el.name, value: el.xp_key })) || []}
          className={styles.selectTop}
          value={date.dtype ?? ''}
          setFieldValue={setFieldValue}
          width={200}
        />
        <div>
          <Button onClick={() => refresh(date)}>Обновить</Button>
        </div>
      </div>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Фамилия Имя Отчество</th>
            <th>Владелец</th>
            <th>Вид документа</th>
            <th>Дата</th>
            <th>Серия</th>
            <th>Номер</th>
            <th>Примечание</th>
          </tr>
        </thead>
        <tbody>

          {docList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
